/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { SELECTION_STYLE_CONTEXT_DO_NOT_USE } from '@atlaskit/menu';
import { N10, N500 } from '@atlaskit/theme/colors';
var sidebarMinWidth = '240px';
var sideNavStyles = css({
  display: 'flex',
  width: '100%',
  minWidth: sidebarMinWidth,
  height: '100%',
  position: 'relative',
  flexDirection: 'column',
  backgroundColor: "var(--ds-surface, ".concat(N10, ")"),
  color: "var(--ds-text-subtle, ".concat(N500, ")"),
  overflow: 'hidden'
});

/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */
var SideNavigation = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    testId = props.testId,
    label = props.label;
  return jsx("nav", {
    ref: ref,
    "data-testid": testId,
    "aria-label": label,
    css: sideNavStyles
  }, jsx(SELECTION_STYLE_CONTEXT_DO_NOT_USE.Provider, {
    value: "notch"
  }, children));
});
export default SideNavigation;